import { Injectable } from '@angular/core';

export class EnvironmentServiceConfig {
    environment: string;
}

@Injectable()
export class EnvironmentService {
    constructor(private config: EnvironmentServiceConfig) { }

    get currentEnvironment() {
        return this.config.environment;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/environment/environment.service.ts